import { formatAddress } from '@/src/utils'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Physician } from '@/src/interfaces'

export const GetDirectionsLink = ({
  physician,
  isProfileCard,
}: {
  physician: Physician
  isProfileCard?: boolean
}) => {
  const address =
    physician.address &&
    formatAddress(
      physician.address,
      physician.city,
      physician.state,
      physician.zip
    )
  const mapQuery =
    address && encodeURIComponent(`${address.line1} ${address.line2}`)

  return (
    <a
      href={`https://www.google.com/maps/search/?api=1&query=${mapQuery}`}
      target='_blank'
      rel='noopener noreferrer'
      className='underline text-sm lg:text-base'
      data-testid='get-directions-link'
    >
      Get Directions{' '}
      {isProfileCard ? <FontAwesomeIcon icon='up-right-from-square' /> : ''}
    </a>
  )
}
